import { clipboardUtils as libClipboardUtils } from "cayo.ui";
import { IDetailsList } from "@cayo/shared/api/types/schema";

const copyGridToClipboard = (grid: IDetailsList | undefined) => {
  const itemDelimeter = "\t";
  const rowDelimiter = "\r\n";
  const result: string[] = [];

  if (grid && grid.items && grid.columns) {
    //set headers
    result.push(
      grid.columns
        .reduce((acc: string[], c) => {
          acc.push(`${c.displayName!}`);
          return acc;
        }, [])
        .join(itemDelimeter)
    );
    // rows
    const fields = grid.columns.map((c) => c.fieldName!);
    grid.items.forEach((row) => {
      result.push(
        fields
          .reduce((acc: string[], field) => {
            acc.push(`${row[field]}`);
            return acc;
          }, [])
          .join(itemDelimeter)
      );
    });
    libClipboardUtils.copyToClipboard(result.join(rowDelimiter));
  }
  libClipboardUtils.copyToClipboard("");
};

const clipboardUtils = { copyGridToClipboard, ...libClipboardUtils };

export default clipboardUtils;
